<div [class.overflow-auto]="overflow()" class="max-h-[20rem] z-20 flex flex-col py-2 rounded-md shadow-md min-w-max border border-gray-200 bg-white">
    <ng-content />
</div>
